import { Outlet } from "react-router";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { MEDIA_CONTENT, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const MediaLibraryProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (canUser(VIEW, MEDIA_CONTENT) === false) {
        return <Forbiddenpage />;
    }

    return <Outlet />;
};
